import { CodeViewer } from '../../common/CodeViewer';

import type { INodeConfigProps } from './index';

/**
 * `compiled-agent` is the workflow compiler's OUTPUT — a deterministic
 * implementation of an llm-agent node, generated by the compiler (not
 * hand-authored). So this form is READ-ONLY: it shows the generated code +
 * provenance instead of the raw-JSON editor (which rendered the code as an
 * escaped one-liner). To change it, re-compile the source node.
 */
export function CompiledAgentConfig({ config }: INodeConfigProps) {
  const code = typeof config.code === 'string' ? config.code : '';
  const sourceNodeKey = typeof config.sourceNodeKey === 'string' ? config.sourceNodeKey : null;
  const compiledModelId =
    typeof config.compiledModelId === 'string' ? config.compiledModelId : null;
  const sourceHash = typeof config.sourceHash === 'string' ? config.sourceHash : null;
  const toolsUsed = Array.isArray(config.toolsUsed) ? (config.toolsUsed as string[]) : [];
  const hasFuzzyFallbacks = config.hasFuzzyFallbacks === true;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--sp-3)' }}>
      <div
        className="alert"
        style={{
          fontSize: 'var(--fs-xs)',
          background: 'var(--surface-2)',
          border: '1px solid var(--border-subtle)',
        }}
      >
        Compiler output — read-only. This node was generated by compiling{' '}
        {sourceNodeKey ? <code className="t-mono">{sourceNodeKey}</code> : 'an llm-agent'}. To
        change it, re-compile the source node.
      </div>

      <div className="field">
        <span className="field-label">Generated code (read-only)</span>
        <CodeViewer code={code} height={360} />
      </div>

      <div className="field">
        <span className="field-label">Provenance</span>
        <div className="t-secondary" style={{ fontSize: 'var(--fs-xs)', lineHeight: 1.6 }}>
          <div>
            Tools: {toolsUsed.length ? toolsUsed.join(', ') : 'none'} ·{' '}
            {hasFuzzyFallbacks ? 'uses llmFallback' : 'fully deterministic'}
          </div>
          {compiledModelId ? (
            <div>
              Compiled by <code className="t-mono">{compiledModelId}</code>
            </div>
          ) : null}
          {sourceHash ? (
            <div>
              Source hash <code className="t-mono">{sourceHash.slice(0, 12)}…</code> (re-compile if
              the source node changed)
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
